import { POLICY_EXCEPTIONS_WRITE } from "@/const/policy-exception.constants"
import { useUser } from "@/hooks/useUser"
import { Loader } from "@/molecules/Loader"
import { LayoutTemplate } from "@/templates/LayoutTemplate"
import { MinimalLayoutTemplate } from "@/templates/MinimalLayoutTemplate"

// Only admins, who review requests, get the app's navigation; a developer just requests.
export const PolicyExceptionLayout = () => {
  const { hasPermission } = useUser()
  // Unknown until the user's role loads: picking a layout now would flash the wrong one.
  const canDecide = hasPermission(POLICY_EXCEPTIONS_WRITE)

  if (canDecide === undefined) return <Loader />

  return canDecide ? <LayoutTemplate /> : <MinimalLayoutTemplate />
}
